import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaFolder,
  FaFileAlt,
  FaSignOutAlt,
  FaUser,
  FaClipboardCheck,
} from "react-icons/fa";
import logo from "../../../assets/irc-logo-rb.png";
import Sidebar from "./Sidebar";

const Evaluation = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState("competition");
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [competitions, setCompetitions] = useState([]);

  const perPage = 6;

  useEffect(() => {
    const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2)
        return parts.pop().split(";").shift();
      return null;
    };
    const idevaluateur = getCookie("idevaluateur");
    if (!idevaluateur) return;

    const apiBase =
      process.env.REACT_APP_API_BASE ||
      process.env.REACT_APP_BACKEND_URL ||
      `${window.location.protocol}//${window.location.hostname}:3001`;
    setLoading(true);
    fetch(
      `${apiBase}/api/evaluateur/competitions?idevaluateur=${encodeURIComponent(
        idevaluateur
      )}`
    )
      .then((r) => r.json())
      .then((json) => {
        if (json?.status === "success") {
          const all = Array.isArray(json.competitions) ? json.competitions : [];
          const filtered = all; // backend already filtered
          setCompetitions(filtered);
        } else setError(json?.message || "Erreur de chargement");
      })
      .catch((e) => setError(String(e)))
      .finally(() => setLoading(false));
  }, []);

  const handleSelect = (idcompetition) => {
    navigate(`/evaluateur/competitions/${idcompetition}/projets`);
  };

  // Compute pagination over competitions
  const totalPages = Math.ceil(competitions.length / perPage) || 1;
  const start = (currentPage - 1) * perPage;
  const currentList = competitions.slice(start, start + perPage);

  const handleToggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };
  const handleItemClick = (item) => {
    setSelectedItem(item);
  };

  const formatDate = (val) => {
    if (!val) return "-";
    const s = String(val);
    if (s.includes("T")) return s.split("T")[0];
    if (s.includes(" ")) return s.split(" ")[0];
    return s;
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <div style={content}>
        <div style={header}>
          <span style={title}>Mes évaluations</span>
        </div>

        <div style={bodyWrapper}>
          {loading && <div>Chargement...</div>}
          {error && <div style={{ color: "red" }}>{error}</div>}
          <div style={grid}>
            {(!loading && !error && currentList.length === 0) && (
              <div style={{ gridColumn: '1 / -1', textAlign: 'center', color: '#475569', fontWeight: 600 }}>Aucune compétition assignée.</div>
            )}
            {currentList.map((c) => (
              <div key={c.idcompetition} style={card}>
                <h3 style={cardTitle}>{c.titre}</h3>
                <p style={meta}>
                  <strong>Libellé:</strong> {c.libelle}
                </p>
                <p style={meta}>
                  <strong>Début:</strong> {formatDate(c.date_debut)}
                </p>
                <p style={meta}>
                  <strong>Fin:</strong> {formatDate(c.date_fin)}
                </p>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    marginTop: 12,
                  }}
                >
                  <button
                    type="button"
                    style={primaryBtn}
                    onClick={() => handleSelect(c.idcompetition)}
                  >
                    Selectioner
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {totalPages > 1 && (
          <div style={paginationContainer}>
            <ul style={paginationList}>
              {Array.from({ length: totalPages }, (_, i) => (
                <li key={i}>
                  <button
                    type="button"
                    style={pageBtn(currentPage === i + 1)}
                    onClick={() => setCurrentPage(i + 1)}
                  >
                    {i + 1}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

const container = {
  display: "flex",
  minHeight: "100vh",
  background: "#e4d2d2",
};
const logoBox = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginBottom: 20,
};
const content = {
  flex: 1,
  padding: 24,
  marginLeft: "15rem",
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  width: "calc(100vw - 22rem)",
};
const header = {
  background: "#e4d2d2",
  border: "1px solid #e6e8eb",
  borderRadius: 12,
  padding: 16,
  boxShadow: "0 4px 12px rgba(16,24,40,0.06)",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 16,
};
const title = { fontSize: "1.25rem", fontWeight: 800, color: "#0b7a3e" };
const bodyWrapper = { display: "flex", flexDirection: "column", flex: 1 };
const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))",
  gap: 16,
  alignItems: "stretch",
};
const card = {
  background: "#fff",
  border: "1px solid #e6e8eb",
  borderRadius: 12,
  padding: 16,
  boxShadow: "0 6px 16px rgba(16,24,40,0.06)",
  width: "100%",
};
const cardTitle = {
  margin: 0,
  fontSize: "1.1rem",
  fontWeight: 700,
  color: "#111827",
};
const meta = { margin: "6px 0", color: "#374151" };
const primaryBtn = {
  padding: "8px 12px",
  borderRadius: 8,
  background: "#0b7a3e",
  color: "#fff",
  border: "none",
  fontWeight: 700,
  cursor: "pointer",
};
// Pagination styles
const paginationContainer = {
  position: "fixed",
  bottom: 24,
  left: "55%",
  transform: "translateX(-50%)",
  display: "flex",
  justifyContent: "center",
  padding: "8px 12px",
  background: "transparent",
  zIndex: 10,
};
// Define pagination list and button styles
const paginationList = {
  listStyle: "none",
  display: "flex",
  gap: 8,
  padding: 0,
  margin: 0,
};
const pageBtn = (active) => ({
  padding: "6px 10px",
  borderRadius: 6,
  border: active ? "1px solid #0b7a3e" : "1px solid #d0d5dd",
  background: active ? "#0b7a3e" : "#fff",
  color: active ? "#fff" : "#0b7a3e",
  fontWeight: 700,
  cursor: "pointer",
});

export default Evaluation;
